import {get, isNil} from "lodash"
import {DeliveryStatus} from "helpers/deliveries"
import {getItemKey} from "helpers/general/lists"
import {getContactName} from "helpers/contacts"
import {
  getJobBoardStatusName,
  getJobCardDeliveryStatus,
  getWorkCentreName,
  isJobCardComplete,
  JobBoardStatus,
} from "helpers/production/index"

export const getJobCardStatusContent = (jobCardStatus, jobCardDeliveryStatus) => {
  return (
      jobCardDeliveryStatus === DeliveryStatus.fullyDelivered
          ? 'Delivered'
          : jobCardDeliveryStatus === DeliveryStatus.partDelivered
              ? 'Part Delivered'
              : getJobBoardStatusName(jobCardStatus)

  )
}

export const getJobCardDepartment = (jobCard, user, productionDepartments) => {
  return getJobCardDeliveryStatus(jobCard, jobCard.order) !== DeliveryStatus.fullyDelivered
      ? isJobCardComplete(jobCard.order, jobCard)
          ? user.settings.productionCompleteName
          : getItemKey(productionDepartments, jobCard.departmentId, 'name')
      : null
}

export const getJobCardOwners = (ownersList) => {
  return ownersList.map(owner =>
      getContactName(get(owner, 'contact', null))).sort().join(', ')
}

export const getWorkCentreOptions = (workCentres, selectedDepartments) => {
  const filteredWorkCentres = (selectedDepartments.includes(-1) || selectedDepartments.length < 1)
      ? workCentres
      : selectedDepartments.map(selectedDepartmentId => {
        return workCentres.filter(workCentre => workCentre.departmentId === selectedDepartmentId)
      }).flat()

  return sortByDepartmentThenWorkCentre(filteredWorkCentres).map(workCentre => {
    return {
      value: workCentre.id,
      label: getWorkCentreName(workCentre),
    }
  })
}

export const getJobCardDesc = (jobCard) => {
  return isNil(jobCard.orderItem)
      ? get(jobCard, 'order.desc')
      : jobCard.description
}

export const sortByDepartmentThenWorkCentre = (workCentres) => {
  return workCentres.sort((a, b) => {
    return a.department.sortOrder - b.department.sortOrder || a.sortOrder - b.sortOrder
  })
}

export const getStatusForColor = (status, deliveryStatus) => {
  return deliveryStatus === DeliveryStatus.fullyDelivered
      ? JobBoardStatus.delivered
      : status
}

export const UserTypes = [
  {value: 'personEstimator', label: 'Estimated By'},
  {value: 'personOwner', label: 'Owner'},
  {value: 'personSalesman', label: 'Salesperson'},
]